// @ts-strict-ignore
/**
 * @fileoverview a thin wrapper around localStorage
 */

/**
 * @note this doesn't actually need to be a class on account of this is a collection
 *   of static methods
 */
export class StorageManager {
  public static readonly KEYS = {
    TEST_KEY: "test",
    LAST_USED_APP_GROUP: "l_ag",
    SHOW_HISTORY_WARNING: "hw",
    SHOW_CAMPAIGNS_IDLE_POPOVER: "cip",
    CAMPAIGN_DIGEST: "campaign_digest_state",
    LAST_GRID_GROUPING: "last_grid_grouping",
    LAST_GRID_SORTING: "last_grid_sorting",
    SELECTED_CUSTOM_EVENTS: "selected_custom_events",
    EXPANDED_TAGS: "expanded_tags",
    HTML_EDITOR: {
      FONT_SIZE: "html_editor_font_size",
      WRAP_TEXT: "html_editor_wrap_text",
    },
    IAM: {
      DO_NOT_SHOW_EMPTY_ATTRIBUTE_WARNING: "do_not_show_empty_attribute_warning",
      DO_NOT_SHOW_FULLSCREEN_IS_MODAL_ON_NONMOBILE_ALERT: "do_not_show_fullscreen_is_modal_on_nonmobile_alert",
    },
    IS_EDITOR_DEBUG_MODE: "iedm",
    PREFERRED_EDITOR: "preferred_editor",
    GRID_SIDEBAR_PANEL_WIDTH: "gspw",
    GRID_CREATED_BY_ME: "gcbm",
    DEV_DEPT_PROMPT_TIME: "ddpt",
    EXPAND_CONTENT_BLOCK_LIVE_PREVIEW: "exp_cb_live",
    VIEWED_CONTACT_CARD_GENERATOR: "viewed_contact_card_generator",
    CATALOG_IMPORT_ERROR_BANNERS: "catalog_import_error_banners",
    CATALOG_SORT_ORDER: {
      COLUMN: "catalog_sort_order_column",
      DIRECTION: "catalog_sort_order_direction",
    },
    HIDE_ACTIVE_DRAFT_CANVAS_WARNING: "hide_active_draft_canvas_warning",
    HIDE_ACTIVE_DRAFT_CAMPAIGN_WARNING: "hide_active_draft_campaign_warning",
    CANVAS_V2_DEFAULT_EDITOR: "canvas_v2_default_editor",
    HIDE_CANVAS_V1_DEPRECATION_BANNER: "hide_canvas_v1_deprecation_banner",
    CANVAS_V2_MIGRATION_BANNER_DISMISS_EXPIRATION_TIME: "dismiss_migration_banner_expiration",
    DISMISS_CAMPAIGN_IDLE_BANNER_EXPIRATION_TIME: "dismiss_campaign_idle_banner_expiration",
    DISMISS_CANVAS_IDLE_BANNER_EXPIRATION_TIME: "dismiss_canvas_idle_banner_expiration",
    DISMISS_CAMPAIGN_TARGETING_COMPLEXITY_BANNER_EXPIRATION_TIME:
      "dismiss_campaign_targeting_complexity_banner_expiration",
    DISMISS_CANVAS_TARGETING_COMPLEXITY_BANNER_EXPIRATION_TIME:
      "dismiss_canvas_targeting_complexity_banner_expiration",
    USER_UPDATE_STEP: {
      HIDE_JSON_CHANGED_WARNING: "hide_json_changed_warning",
    },
    IA_V1_PREVIEW: {
      SHOW_NEW_IA: "ia_v1_preview.show_new_ia",
      SEEN_NEW_IA_TOUR_MODAL: "ia_v1_preview.seen_new_ia_tour_modal",
      NAV_IA_TOUR_COMPLETE: "ia_v1_preview.nav_ia_tour_complete",
      PROMPT_FEEDBACK: "ia_v1_preview.prompt_feedback",
    },
    REACT_NAV: {
      SEEN_REACT_NAV_TOUR_MODAL: "react_nav.seen_react_nav_tour_modal",
      PROMPT_REACT_NAV_TOUR: "react_nav.prompt_react_nav_tour",
      PROMPT_FEEDBACK: "react_nav.prompt_feedback",
    },
    HIDE_SQL_EDITOR_BANNER: "hide_sql_editor_banner",
    LINK_SHORTENING_DOMAINS_POPOVER: "link_shortening_domains_popover",
    HIDE_INCREMENTAL_SQL_EDITOR_BANNER: "hide_incremental_sql_editor_banner",
    EMAIL_INBOX_VISION_FILTER_VALUES: "email_inbox_vision_filter_values",
    EMAIL_DRAFT_RECOVERY: "edr",
    LINE_DRAFT_RECOVERY: "ldr",
    BANNER_DRAFT_RECOVERY: "bdr",
    HIDE_TRANSLATION_TAG_INFO: "hide_translation_tag_info",
    TRANSLATION_TAG_TOOLTIP_SHOWINGS: "translation_tag_tooltip_showings",
    EMAIL_SENDER_VERIFICATION_COMPLETE_BANNER_SHOWN: "email_sender_verification_complete_banner_shown",
    HIDE_QUERY_BUILDER_VARIABLES_BANNER: "hide_query_builder_variables_banner",
    HIDE_QUERY_BUILDER_SEGMENTS_VARIABLES_BANNER: "hide_query_builder_segments_variables_banner",
    SEGMENT_NEW_FILTER_COMPOSER: "segment_filter_composer_version",
    FCM_MIGRATION_WARNING_MODAL_SUPPRESSED: "fcm_migration_suppression_v2",
    FCM_MIGRATION_WARNING_MODAL_LAST_INTERACTED: "fcm_migration_interacted",
    FREE_TRIAL_IMPORT_LIMITS_ALERT_MODAL_LAST_SUPPRESSED: "ft_import_limits_suppressed",
    HIDE_CATALOGS_ON_EVENT_PROPERTIES_TEMPLATE_BANNER: "hide_catalogs_on_event_properties_template_banner",
    HIDE_CATALOGS_ON_PURCHASE_PROPERTIES_TEMPLATE_BANNER: "hide_catalogs_on_purchase_properties_template_banner",
    WHATS_APP_RESPONSE_MESSAGING_LAUNCH_BANNER: "whats_app_response_messaging_launch_banner",
    WHATS_APP_TEMPLATE_TABLE_VIEW_MODE: "whats_app_template_table_view_mode",
    HIDE_FEATURE_FLAGS_EXPERIMENTS_BANNER: "hide_feature_flags_experiments_banner",
    SHOW_CDI_SEGMENT_EXTENSION_WALKTHROUGH: "show_cdi_segment_extension_walkthrough",
    HIDE_USING_DATABRICKS_FOR_CDI_SQL_EDITOR_BANNER: "hide_using_databricks_for_cdi_sql_editor_banner",
    MARKETO_UTM_PARAMS: "marketo_utm_params",
    OPEN_MULTI_LANGUAGE_SIDEBAR_PANEL: "open_multi_language_sidebar_panel",
    HIDE_CANVAS_CCAW_INTRO: "hide_canvas_ccaw_intro",
    HIDE_TPA_INTRO: "hide_tpa_intro",
    HIDE_CAMPAIGN_LOOKBACK_WARNING: "hide_campaign_lookback_warning",
    HIDE_CANVAS_LOOKBACK_WARNING: "hide_canvas_lookback_warning",
    HIDE_FEATURE_FLAG_ADD_RULE_INFO: "hide_feature_flag_add_rule_info",
    ENABLE_BRAZE_DEBUG_TOOL: "enable_braze_debug_tool",
    SHOPIFY_CATALOG_UPGRADE_REQUESTED: "shopify_catalog_upgrade_requested",
    CATALOG_STORAGE_UPGRADE_REQUESTED: "catalog_storage_upgrade_requested",
    ENABLE_OPERATOR_DEBUG_MODE: "enable_operator_debug_mode",
    OPERATOR_DEBUG_HIDE_ENABLED_ELEMENTS: "operator_debug_hide_enabled_elements",
    HIDE_SURVEY_CONTACT_INFO_BANNER: "hide_survey_contact_info_banner",
    OPERATOR_AUTO_APPROVE_SKIP_CONFIRMATION: "operator_auto_approve_skip_confirmation",
    OPERATOR_AUTO_LOADED: "operator_auto_loaded",
    AUTOMATIC_VARIANT_SELECTION_SKIP_MODAL: "automatic_variant_selection_skip_modal",
    BRAZE_DEBUG_PERSIST_FF_OVERRIDES: "braze_debug_persist_ff_overrides", // boolean. Local behaviour setting. Writes FF overrides to local storage
    BRAZE_DEBUG_FF_OVERRIDES: "braze_debug_ff_overrides", // Map of string->boolean The persisted overrides
  };

  private static listeners: Map<string, ((value: any) => void)[]> = new Map();

  public static parseGridId(gridId: string | null): string {
    return (gridId || "").replace(/ /g, "_");
  }

  public static getKeyForGridSorting(gridId: string): string {
    return `${StorageManager.KEYS.LAST_GRID_SORTING}:${StorageManager.parseGridId(gridId)}`;
  }

  public static getKeyForExpandedTags(uniqueTag: string): string {
    return `${StorageManager.KEYS.EXPANDED_TAGS}:${uniqueTag}`;
  }

  public static getKeyForGridSidebarPanelWidth(gridName: string): string {
    return `${StorageManager.KEYS.GRID_SIDEBAR_PANEL_WIDTH}:${gridName}`;
  }

  public static getKeyForGridCreatedByMe(gridName: string): string {
    return `${StorageManager.KEYS.GRID_CREATED_BY_ME}:${gridName}`;
  }

  public static getKeyForCatalogImportErrorBanners(appGroupId: string): string {
    return `${StorageManager.KEYS.CATALOG_IMPORT_ERROR_BANNERS}:${appGroupId}`;
  }

  public static getKeyForEmailDraftRecovery(uniqueKey: string): string {
    return `${StorageManager.KEYS.EMAIL_DRAFT_RECOVERY}:${uniqueKey}`;
  }

  public static getKeyForLineDraftRecovery(uniqueKey: string): string {
    return `${StorageManager.KEYS.LINE_DRAFT_RECOVERY}:${uniqueKey}`;
  }

  public static getKeyForBannerDraftRecovery(uniqueKey: string): string {
    return `${StorageManager.KEYS.BANNER_DRAFT_RECOVERY}:${uniqueKey}`;
  }

  public static getKeyForShopifyCatalogUpgradeRequested(appGroupId: string): string {
    return `${StorageManager.KEYS.SHOPIFY_CATALOG_UPGRADE_REQUESTED}:${appGroupId}`;
  }

  public static localStorageIsSupported(): boolean {
    try {
      if (localStorage && localStorage.getItem) {
        try {
          localStorage.setItem(StorageManager.KEYS.TEST_KEY, "true");
          if (localStorage.getItem(StorageManager.KEYS.TEST_KEY)) {
            localStorage.removeItem(StorageManager.KEYS.TEST_KEY);
          }
          return true;
        } catch (e) {
          return (
            (e.code == 22 ||
              e.name == "QuotaExceededError" ||
              // Older versions of Firefox
              e.code == 1014 ||
              e.name == "NS_ERROR_DOM_QUOTA_REACHED") &&
            localStorage.length > 0
          );
        }
      }
    } catch {
      return false;
    }
    return false;
  }

  public static get<T = any>(key: string): T {
    if (!StorageManager.localStorageIsSupported()) {
      return null;
    }

    const stored = localStorage[key];
    if (stored == null) {
      return null;
    }

    try {
      return JSON.parse(stored);
    } catch {
      return stored;
    }
  }

  public static set<T = any>(key: string, value: T): void {
    if (StorageManager.localStorageIsSupported() && value != null) {
      try {
        const serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
        StorageManager.listeners.get(key)?.forEach((callback) => callback(value));
      } catch {
        return;
      }
    }
  }

  public static remove(key: string): void {
    if (!StorageManager.localStorageIsSupported()) {
      return null;
    }

    localStorage.removeItem(key);
  }

  public readonly KEYS: typeof StorageManager.KEYS;

  constructor() {
    this.KEYS = StorageManager.KEYS;
  }

  public localStorageIsSupported(): boolean {
    return StorageManager.localStorageIsSupported();
  }

  public get<T = any>(key: string): T {
    return StorageManager.get(key);
  }

  public set<T = any>(key: string, value: T): void {
    StorageManager.set(key, value);
  }

  public remove(key: string): void {
    StorageManager.remove(key);
  }

  public listen(key: string, callback: (value: any) => void): void {
    if (!this.localStorageIsSupported()) {
      return null;
    }

    window.addEventListener("storage", (event) => {
      if (event.key === key) {
        callback(this.get(key));
      }
    });

    if (!StorageManager.listeners.has(key)) {
      StorageManager.listeners.set(key, []);
    }

    StorageManager.listeners.get(key)?.push(callback);
  }

  public unlisten(key: string, callback: (value: any) => void): void {
    if (!StorageManager.listeners.has(key)) {
      return;
    }

    const listeners = StorageManager.listeners.get(key);
    if (!listeners) {
      return;
    }
    const listening = listeners.indexOf(callback);
    if (listening !== -1) {
      listeners.splice(listening, 1);
    }
  }
}
